<template>
<div>
  <div>
    <div>
      <el-descriptions :column="2" border size="mini" :labelStyle="{width: '100px'}" :contentStyle="{width:'41%'}">
        <el-descriptions-item label="项目房产">
          {{mainObj.house_name?mainObj.house_name:'请选择项目房产'}}
        </el-descriptions-item>
        <el-descriptions-item label="抄表月份">
          <el-date-picker
            v-model="mainObj.read_month"
            size="mini"
            type="month"
            format="yyyy-MM"
            value-format="yyyy-MM"
            placeholder="选择月">
          </el-date-picker>
        </el-descriptions-item>
        <el-descriptions-item label="仪表编号">
          <el-input size="mini" placeholder="请输入仪表编号" v-model="meterObj.number" clearable></el-input>
        </el-descriptions-item>
        <el-descriptions-item label="仪表类型">
          <el-select size="mini" style="width: 100%" v-model="meterObj.meter_type" clearable filterable placeholder="类型" class="kuan">
            <el-option v-for="item in meter_type_list" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-descriptions-item>
        <el-descriptions-item label="识别操作">
          <el-button type="primary" size="mini" @click="ocr()">选择图片</el-button>
          <el-link style="margin-left: 10px;" type="primary" @click="setRunImage('2024/04/09/微信图片_20240329140227_1712634761839.jpg',2)">电表示例</el-link>
          <el-link style="margin-left: 10px;" type="primary" @click="setRunImage('2024/04/09/e7aa24aa521867e61a2e44789447182e_1712634794392.jpeg',1)">水表示例</el-link>
        </el-descriptions-item>
        <el-descriptions-item label="结果处理">
          <el-button type="primary" size="mini" @click="confirm()">确认取数</el-button>
          <el-button type="danger" size="mini" :disabled="!is_deny_upload" @click="deny()">识别异常</el-button>
        </el-descriptions-item>
        <el-descriptions-item label="说明">
          <div style="font-size: 14px;">
            <p>1.拍照读数在本模块主要用于检测图片读数的正确的， 也是对移动端的拍照读表度数的的检测，如果存在识别不了或者识别异常的，请在【选择图片】后点击【识别异常】，提交图片，我们会采集大家提交的异常图片进行训练，增强拍照读表的识别率。</p>
            <p>2.仪表读数目前支持水表和电表的识别。水表只识别【读数】；电表识别【读数+表号】</p>
            <p>3.图片的选取请尽量是目测可读的，多角度的。</p>
            <p>4.移动端抄表
              <el-popover
                placement="right"
                title="扫码"
                width="300"
                trigger="hover">
                <el-image :src="host_url+'static/meter_url.png'" fit="cover"></el-image>
                <el-link type="primary" slot="reference">二维码</el-link>
              </el-popover>
              。
            </p>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </div>
  <div>
    <div class="time-out">识别耗时：{{read_out_time}}</div>
    <div class="meter_ocr_data">
      <table class="meter_ocr_data-table" cellpadding="0" cellspacing="0">
        <tr class="meter_ocr_data-item">
          <td><span style="font-weight: bold;">数据</span></td>
          <td><span style="font-weight: bold;">精度</span></td>
        </tr>
        <tr class="meter_ocr_data-item" v-for="item in meter_ocr_data">
          <td><span :class="is_read_ocr?'ok':'no'">{{item.text}}</span></td>
          <td><span :class="is_read_ocr?'ok':'no'">{{item.rate*100}} %</span></td>
        </tr>
      </table>
    </div>
  </div>
  <div class="meter-img">
    <div class="meter-img-item">
      <img id="img-src" class="meter-img-item-img" v-if="img_src" :src="img_src" alt="请上传图片">
    </div>
    <div class="meter-img-item">
      <canvas id="myCanvas" v-if="img_src" width="200" height="100">
      </canvas>
    </div>
  </div>
  <el-dialog
    :visible.sync="dialogVisible"
    width="90vw"
    :close-on-click-modal="false"
    append-to-body
    @close="onClose"
  >
    <MeterImageMarker v-if="dialogVisible" />
  </el-dialog>
</div>
</template>

<script>
import Http from "../../common/Http";
import DrawOcr from "../../common/DrawOcr";
import MeterImageMarker from "./components/MeterImageMarker";
import MeterHttp from "../../common/MeterHttp";

export default {
  name: "MeterOcr",
  components: {MeterImageMarker},
  inject:['mainObj','componentId','setComponentId'],
  data(){
    return{
      host_url:"https://meter.gdzawy.com:9001/",
      meterObj:{
        number:"",
        meter_type:2
      },
      meter_type_list:[],
      meter_type_ocr:{
        1:"sb",
        2:"db",
        3:"qb",
        4:"yb",
        5:"rsb"
      },
      img_file:"",
      img_src:"",
      meter_ocr_data:[],
      is_read_ocr:true,
      read_out_time:"",
      dialogVisible:false,
      is_deny_upload:false,
    }
  },
  mounted() {
    this.getMeterTypeList();
  },
  methods:{
    getMeterTypeList(){
      const that = this;
      let where={};
      MeterHttp.get("MeterType/getList",{
        project_id:that.mainObj.project_id,
        where:JSON.stringify(where),
        field:"id,name,expenditure_ids,expenditure_name",
        page: 1,
        page_size: 200
      },ret=>{
        if(ret.code){
          that.meter_type_list=ret.data.list;
        }
      })
    },
    ocr(){
      const that=this;
      Http.selectFile(file=>{
        that.runImage(file);
      })
    },
    confirm(){
      this.$message.error("感谢支持，目前暂不支持！");
      // drawOcr.
    },
    deny(){
      const that=this;
      __OSS__.setBucket("gdza").fileToUpload(that.img_file,data=>{
        Http.post("https://meter.gdzawy.com:9001/admin/MeterNote/denyOcr",{
          meter_type:that.meterObj.meter_type,
          img_path:data.path,
          ocr_text:JSON.stringify(that.meter_ocr_data),
          position:"",
        },ret=>{
          if(ret.code){
            that.$message.success(ret.msg);
            that.is_deny_upload=false;
          }else {
            that.$message.error(ret.msg||"提交异常");
          }
        })
      })
    },
    onClose(){
      this.dialogVisible=false;
    },

    runImage(img_url){
      const that=this;
      that.img_file=img_url;
      const reader = new FileReader(); // 创建FileReader对象
      reader.onload = function(e) {
        that.img_src=e.target.result;
        let img = new Image();
        img.onload = function() {
          // console.log('宽度: ' + img.width);
          // console.log('高度: ' + img.height);
          that.is_deny_upload=true;
          const base64 = e.target.result.replace(/^data:image\/\w+;base64,/, "");//去掉base64位头部;
          // 在这里处理Base64字符串，例如可以将其显示在页面上
          // console.log(base64);
          ERP.postRequest({
            url: "https://meter.gdzawy.com:9001/admin/MeterNote/ocrPrediction",
            data: {
              meter_type:that.meter_type_ocr[that.meterObj.meter_type]||"db",
              key:"image",
              value:base64
            }
          }, res => {
            if (res.code) {
              const drawOcr=new DrawOcr("myCanvas",document.getElementById("img-src"),img);
              let pos=res.data.map(rets=>rets.position)
              drawOcr.setPostion(pos)
              that.read_out_time=res.time
              that.meter_ocr_data=res.data;
            }
          })
        };
        img.src = e.target.result;

      };

      reader.onerror = function(e) {
        console.error("File could not be read! Code " + e.target.error.code);
      };

      reader.readAsDataURL(img_url); // 读取文件并转换为Base64
    },

    setRunImage(img_url,meter_type=2){
      const that=this;
      that.meterObj.meter_type=meter_type;
      __OSS__.setBucket("gdza").setKey(img_url).getBlob(url=>{
        that.runImage2(url)
      })
    },
    runImage2(img_url){
      const that=this;
      that.img_file=img_url;
      that.img_src=img_url;
      const reader = new FileReader(); // 创建FileReader对象
      reader.onload = function(e) {
        that.img_src=e.target.result;
        let img = new Image();
        img.onload = function() {
          // console.log('宽度: ' + img.width);
          // console.log('高度: ' + img.height);
          that.is_deny_upload=false;

          const base64 = e.target.result.replace(/^data:(.*?)base64,/, "");//去掉base64位头部;
          // 在这里处理Base64字符串，例如可以将其显示在页面上
          // console.log(base64);
          ERP.postRequest({
            url: "https://meter.gdzawy.com:9001/admin/MeterNote/ocrPrediction",
            data: {
              meter_type:that.meter_type_ocr[that.meterObj.meter_type]||"db",
              key:"image",
              value:base64
            }
          }, res => {
            if (res.code) {
              const drawOcr=new DrawOcr("myCanvas",document.getElementById("img-src"),img);
              let pos=res.data.map(rets=>rets.position)
              drawOcr.setPostion(pos)
              that.read_out_time=res.time
              that.meter_ocr_data=res.data;
            }
            // that.loading = false;
          })
        };
        img.src = e.target.result;

      };

      reader.onerror = function(e) {
        console.error("File could not be read! Code " + e.target.error.code);
      };

      reader.readAsDataURL(img_url); // 读取文件并转换为Base64
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../common";
.meter-img{
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  .meter-img-item{
    display: block;
    .meter-img-item-img{
      width: 300px;
    }
  }
}

.time-out{
  padding: 5px;
}
.meter_ocr_data{
  padding: 5px;
  .meter_ocr_data-table{
    width: 100%;
    //border: 1px solid #d7d7d7;
    .meter_ocr_data-item{
      td{
        padding: 2px 5px;
        border: 1px solid #d7d7d7;
        .ok{
          color: #06a328;
        }

        .no{
          color: #454645;
        }
      }
    }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/Admin/EnergyConsumption/components/meter_note/MeterOcr.vue